<template>
  <e-dialog
    dialog-title="设置您的核心产品"
    :center-dialog-visible="visible"
    popup-width="820px"
    @resetPopupData="onCancel"
    @submitPopupData="onOk"
  >
    <div style="height: 500px">
      <div class="set-tips">
        <span>说明：</span>
        每个目录下配置10个商品数据，展示优先级根据排序决定，若商品下架或停用，则使用同目录下的商品进行补位
      </div>
      <e-tabs :active="currentActive" :pane-list="paneList" @handleTabClick="handlePurchaseTabClick"></e-tabs>
      <table-list
        :loading="false"
        :index-show="true"
        index-label="排序"
        max-height="380px"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #defaultimage="{ scope: { row } }">
          <el-image
            v-if="row.defaultimage"
            :src="row.defaultimage"
            fit="fit"
            style="width: 120px; height: 60px"
          ></el-image>
        </template>
        <template #operation="{ scope: { $index } }">
          <eui-btn type="text" @click="up($index)">上移</eui-btn>
          <eui-btn type="text" @click="down($index)">下移</eui-btn>
          <eui-btn type="text" @click="del($index)">删除</eui-btn>
        </template>
      </table-list>
    </div>

    <addProductDialog
      v-if="goodsVisible"
      :goods-visible.sync="goodsVisible"
      :params="params"
      @onChoose="onChoose"
    ></addProductDialog>
  </e-dialog>
</template>

<script>
import tableList from '@/modules/projectA/components/common/e-table-list.vue';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import ETabs from './e-tabs.vue';

import addProductDialog from './addProductDialog.vue';

export default {
  components: { tableList, EDialog, ETabs, addProductDialog },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    paneList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      currentActive: '0',
      tableLoading: false,
      goodsVisible: false,
      tableData: [],
      tableLabel: [
        {
          label: '图片',
          slot: 'defaultimage',
          align: 'center',
          width: '160',
        },
        {
          label: '商品编号',
          param: 'skucode',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '商品名称',
          param: 'skuname',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '市场价',
          param: 'price',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'operation',
          fixed: 'right',
          width: '150',
        },
      ],
      tabsKey: 0,
    };
  },
  methods: {
    onChoose(val) {
      const itemObj = this.paneList.find((item) => item.name === this.currentActive);
      itemObj.tableData = val;
      this.tableData = [...val];
    },
    handlePurchaseTabClick(currentActive, val) {
      console.log(currentActive, val);
      const itemObj = this.paneList.find((item) => item.name === currentActive);
      this.tableData = itemObj.tableData || [];
      console.log(itemObj, 'itemObj');
      this.currentActive = currentActive;
      const { companyId: supplierCompanyId } = this.$store.state.USERINFO;
      const params = {
        supplierCompanyId,
      };
      switch (itemObj.categoryLevel) {
        case 1:
          params.firstcategoryList = [itemObj.categoryCode];
          break;
        case 2:
          params.secondcategoryList = [itemObj.categoryCode];
          break;
        case 3:
          params.thirdcategoryList = [itemObj.categoryCode];
          break;
        case 4:
          params.fourthcategoryList = [itemObj.categoryCode];
          break;
        default:
          break;
      }
      this.params = params;
      this.goodsVisible = true;
    },
    onCancel() {
      this.$emit('update:visible', false);
    },
    onOk() {
      console.log(this.paneList, 'this.paneList');
      this.$emit('onSetting', this.paneList);
      this.onCancel();
    },
    up(index) {
      if (index > 0) {
        const obj = this.tableData.splice(index, 1);
        this.tableData.splice(index - 1, 0, obj[0]);
      }
    },
    down(index) {
      if (index < this.tableData.length) {
        const obj = this.tableData.splice(index, 1);
        this.tableData.splice(index + 1, 0, obj[0]);
      }
    },
    del(index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.set-tips {
  padding: 15px 10px;
  font-size: 14px;
  color: #333;
  background: #e8efff;
  span {
    color: #f0250f;
  }
}
.add-box {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.disabled {
  color: #999999;
}
</style>
